import { render, staticRenderFns } from "./ReturnProduct.vue?vue&type=template&id=2bf4a366&"
var script = {}
import style0 from "./ReturnProduct.vue?vue&type=style&index=0&id=2bf4a366&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports